<template>
    <div style="max-width: 770px;">
       <Steps steps="4" current="4" links="true" />
        
        <form @submit.prevent="validateBeforeSubmit">
            <div class="txt-grey">Step 4</div>
            <h3 class="uc">Employment Information</h3>
            <p class="light mb-4">Tell us a little bit about your income and employment.</p>
             <fieldset class="mb-3">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <div class="form-group mb-0">
                            <div class="mt-3 mb-2 check-label">What's your income type?</div>                           
                            <div class="radio-options">
                                <div class="radio-option align-items-center" :class="employmentType == 'employed' ? 'selected' : ''" @click="employmentType='employed'">
                                    Employed
                                </div>
                                <div class="radio-option" :class="employmentType == 'benefits' ? 'selected' : ''" @click="employmentType='benefits'">
                                    Benefits
                                </div>
                                <div class="radio-option" :class="employmentType == 'self-employed' ? 'selected' : ''" @click="employmentType='self-employed'">
                                    Self-Employed
                                </div>
                                <div class="radio-option" :class="employmentType == 'military' ? 'selected' : ''" @click="employmentType='military'">
                                    Military or Dependent
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <div class="form-group mb-0">
                            <div class="mt-3 mb-2 check-label">How frequently are you paid?</div>                           
                            <div class="radio-options">
                                <div class="radio-option" :class="payFrequency == 'weekly' ? 'selected' : ''" @click="payFrequency='weekly'">
                                    Weekly
                                </div>
                                <div class="radio-option align-items-center" :class="payFrequency == 'biweekly' ? 'selected' : ''" @click="payFrequency='biweekly'">
                                    Bi-Weekly
                                </div>
                                <div class="radio-option" :class="payFrequency == 'semi-monthly' ? 'selected' : ''" @click="payFrequency='semi-monthly'">
                                    Twice Monthly
                                </div>
                                <div class="radio-option" :class="payFrequency == 'monthly' ? 'selected' : ''" @click="payFrequency='monthly'">
                                    Monthly
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <div class="form-group mb-0">
                            <div class="mt-3 mb-2 check-label">How are you paid?</div>                           
                            <div class="radio-options">
                                <div class="radio-option" :class="payType == 'direct_deposit' ? 'selected' : ''" @click="payType='direct_deposit'">
                                    Direct Deposit
                                </div>
                                <div class="radio-option align-items-center" :class="payType == 'check' ? 'selected' : ''" @click="payType='check'">
                                    Paper Check
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             </fieldset>
             <fieldset class="mb-3">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <BasicInput
                            label="What's your employer's name?"
                            id="employerName"
                            name="employerName"
                            v-model="employerName"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('employerName')" 
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="How long have you worked there?"
                            id="monthsEmployed"
                            name="monthsEmployed"
                            v-model="monthsEmployed"
                            v-validate="'required'"
                            :options="[{value: '84', label: '7 years or more'}, {value: '72', label: '6 years'}, {value: '60', label: '5 years'}, {value: '48', label: '4 years'}, {value: '36', label: '3 years'}, {value: '24', label: '2 years'}, {value: '12', label: 'One year or less'}]"
                            errormsg="This is a required field"
                            :error="errors.first('monthsEmployed')" 
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="What is your monthly income?"
                            id="monthlyIncome"
                            name="monthlyIncome"
                            v-model="monthlyIncome"
                            v-validate="'required'"
                            :options="[{value: '6000', label: 'More than $5,000'}, {value: '5000', label: '$4500 - $5000'}, {value: '4500', label: '$4001 - $4500'}, {value: '4000', label: '$3501 - $4000'}, {value: '3500', label: '$3001 - $3500'}, {value: '3000', label: '$2501 - $3000'}, {value: '2500', label: '$2001 - $2500'}, {value: '1000', label: '$1000 or less'}, {value: '2000', label: '$1501 - $2000'}, {value: '1500', label: '$1001 - $1500'}]"
                            errormsg="This is a required field"
                            :error="errors.first('monthlyIncome')" 
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="When is your next pay day?"
                            id="nextPaydate"
                            name="nextPaydate"
                            v-model="nextPaydate"
                            v-validate="'required'"
                            :options="paymentDates"
                            errormsg="This is a required field"
                            :error="errors.first('nextPaydate')" 
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-7 col-xl-6">
                        <CleaveInput
                            label="Work phone number"
                            id="workPhone"
                            name="workPhone"
                            type="tel"
                            maxlength="12"
                            :cleaveoptions="masks.workPhone"
                            help="Lenders require this to verify employment, you must provide an accurate number to obtain a loan.<br><br>Format: 999-999-9999."
                            v-model="workPhone"
                            v-validate="{ required: true, validateAreaCode: true, regex: /^[0-9]{3}\-[0-9]{3}\-[0-9]{4}$/ }"
                            :exval="validationAttempt"
                            :error="errors.first('workPhone')"
                        />
                    </div>
                    <div class="col-lg-3 col-xl-2">
                        <CleaveInput
                            label="Extension"
                            id="workExt"
                            name="workExt"
                            maxlength="7"
                            :cleaveoptions="masks.workExt"
                            type="tel"
                            v-model="workExt"
                            :exval="validationAttempt"
                            :error="errors.first('workExt')"
                        />
                    </div>
                </div>
             </fieldset>

            <div class="my-5 d-flex align-items-center">
                <button class="btn btn-cta btn-red uc" id="form-submit">{{saving ? 'Saving...' : 'Continue'}}</button>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
            </div>
        
        </form>
    </div>
</template>

<script>
import BasicInput from '@/components/form/BasicInput.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';
require('../../../node_modules/cleave.js/dist/addons/cleave-phone.us.js');
import Select from '@/components/form/Select.vue';
import Steps from '@/components/form/Steps.vue';
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';

export default {
    name: 'FormStep4',
    title: 'Register | Step 4',
    components:{
        BasicInput,
        CleaveInput,
        Select,
        Steps
    },
    data() {
	  return {
            saving: false,
            validationAttempt: false,

            employmentType: 'employed',
            employerName: '',
            monthsEmployed: '',
            monthlyIncome: '',
            payFrequency: 'biweekly',
            nextPaydate: '',
            secondPayDate: '',
            workPhone: '',
            workExt: '',
            payType: 'direct_deposit',

            masks: {
                workPhone: { phone: true, phoneRegionCode: 'US', delimiter: '-'},
                phone: { numericOnly: true, delimiter: '-', blocks: [3, 3, 4] },
                workExt: { numericOnly: true, blocks: [7]  }
            }
		}
    },
    watch: {
        nextPaydate: 'calculateSecondPaymentDate',
        payFrequency: 'calculateSecondPaymentDate',
    },
    methods: {
        ...mapActions(['saveFormData']),
        isWeekend(date){
            if(date.isoWeekday() == 6 || date.isoWeekday() == 7){
                return true;
            } else {
                return false;
            }
        },
        calculateSecondPaymentDate(){
            if(this.nextPaydate == '' || this.payFrequency == ''){
                return false;
            }
            let addDays = 0;
            let secondPayDate = moment(this.nextPaydate, "YYYY-MM-DD");
            
            switch(this.payFrequency){
                case "weekly":
                    secondPayDate.add(1, 'weeks');       
                break;
                case "biweekly":
                    secondPayDate.add(2, 'weeks');
                break;
                case "semi-monthly":
                    secondPayDate.add(15, 'days');
                break;
                case "monthly":
                    secondPayDate.add(1, 'months');
                break;
                default:
                    secondPayDate.add(1, 'months');
            }

            while(this.isWeekend(secondPayDate)){
                secondPayDate.subtract(1, 'days');
            }
            this.secondPayDate = secondPayDate.format('YYYY-MM-DD');
            
        },
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
                        'employmentType': this.employmentType,
                        'employerName': this.employerName,
                        'monthsEmployed' : this.monthsEmployed,
                        'monthlyIncome' : this.monthlyIncome,
                        'payFrequency' : this.payFrequency,
                        'nextPaydate' : this.nextPaydate,
                        'secondPayDate' : this.secondPayDate,
                        'workPhone' : this.workPhone,
                        'workExt' : this.workExt,
                        'payType' : this.payType,
						'fourthStep': true,
                    });
                    this.$router.push({ path: '/registration/5' });
                    return;
                }
                this.saving = false;
      		});
        },
    },
    computed: {
        ...mapGetters(["formData"]),
        paymentDates() {
            let now = moment();
            const paymentDates = [];
            let thisDay = now.isoWeekday();
            const daysThisWeek = 5 - thisDay;
            const daysNextWeek = (7 - thisDay) + 5;
            let prefix = "";
            let count = 0;
            
            for(let i=0; i < 30; i++){
                // Make it next day
                now = now.add(1, "days");
                thisDay = thisDay == 7 ? 1 : thisDay + 1;
                
                switch(true) {
                    case i === 0:
                        prefix = "Tomorrow, ";
                        break;
                    case count <= daysThisWeek: 
                        prefix = "This ";
                        break;
                    case count > daysThisWeek && count <= daysNextWeek:
                        prefix = "Next ";
                        break;
                    default:
                        prefix = '';
                }

                if(thisDay != 6 && thisDay != 7) {
                    paymentDates.push({value: now.format("YYYY-MM-DD"), label: prefix + now.format("dddd, MM-DD-YYYY")});
                }
                count++;
            }
            return paymentDates;
        }
    },
    created(){       
        this.employmentType = this.formData.employmentType || 'employed';
        this.employerName = this.formData.employerName || '';
        this.monthsEmployed = this.formData.monthsEmployed || '';
        this.monthlyIncome = this.formData.monthlyIncome || '';
        this.payFrequency = this.formData.payFrequency || 'biweekly';
        this.nextPaydate = this.formData.nextPaydate || '';
        this.secondPayDate = this.formData.secondPayDate || '';
        this.workPhone = this.formData.workPhone || '';
        this.workExt = this.formData.workExt || '';
        this.payType = this.formData.payType || 'direct_deposit';
    }
}

</script>

<style>
    
</style>
